import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{d-icon this.icon}}",{ moduleName: "discourse/components/flat-button.hbs" })